import { SquareIcon } from 'lucide-react'
import { Category } from '@wellesley/openapi'

export type CategoryIconProps = {
  category: Category
  className?: string
}

export const CategoryIcon = ({ category, className }: CategoryIconProps) => (
  <SquareIcon
    size={14}
    fill={category.meta?.color || '#000000'}
    className={className}
    data-testid="category-icon"
  />
)
